import answerPreset from './answer';
import appStore from './app-store';
import articlePreset from './article';
import bannerPreset from './banner';
import bannerReadOnlyPreset from './banner-read-only';
import botBuilderPreset from './bot-builder';
import botBuilderWithAttributeInserterPreset from './bot-builder-with-attribute-inserter';
import carouselScreenContentBlock from './carousel-screen-content-block';
import changePagePreset from './change-page';
import conversationCardNote from './conversation-card-note';
import conversationCardNoteDisableUploads from './conversation-card-note-disable-uploads';
import conversationCardReply from './conversation-card-reply';
import conversationCardReplyDisableUploads from './conversation-card-reply-disable-uploads';
import debugPreset from './debug';
import defaultConfig from './default';
import developerHub from './developer-hub';
import educateAutoMessagePreset from './educate-auto-message';
import emailPreset from './email';
import emailPlainPreset from './email-plain';
import facebookMessagePreset from './facebookMessage';
import imageTextInputPreset from './image-text-input';
import inAppAnnouncementPreset from './in-app-announcement';
import inAppAnnouncementMobilePreset from './in-app-announcement-mobile';
import inAppAnnouncementVideoPreset from './in-app-announcement-video';
import inAppBigAnnouncementPreset from './in-app-big-announcement';
import inAppBigAnnouncementMobilePreset from './in-app-big-announcement-mobile';
import inAppBigAnnouncementVideoPreset from './in-app-big-announcement-video';
import inAppChatPreset from './in-app-chat';
import inAppChatMobilePreset from './in-app-chat-mobile';
import inAppChatVideoPreset from './in-app-chat-video';
import inAppMv2ChatPreset from './in-app-mv2-chat';
import inAppMv2ChatMobilePreset from './in-app-mv2-chat-mobile';
import inAppPointerPreset from './in-app-pointer';
import inboxNote from './inbox-note';
import inboxNoteDisableUploads from './inbox-note-disable-uploads';
import inboxReply from './inbox-reply';
import inboxReplyDisableUploads from './inbox-reply-disable-uploads';
import productTourStep from './product-tour-step';
import productTourStepVideo from './product-tour-step-video';
import pushOnlyPreset from './push-only';
import pushOnlyDisallowAttribute from './push-only-disallow-attribute';
import pushOnlyReadOnlyPreset from './push-only-read-only';
import readOnlyPreset from './read-only';
import readOnlyCanaryPreset from './read-only-canary';
import readOnlyChatPreset from './read-only-chat';
import readOnlyEmailPreset from './read-only-email';
import savedContent from './saved-content';
import savedReplyPreset from './saved-reply';
import simpleComposerPreset from './simple-composer';
import simpleComposerCanaryPreset from './simple-composer-canary';
import simpleLegacyComposerEmailPreset from './simple-legacy-composer-email';
import simpleLegacyComposerInAppAnnouncementPreset from './simple-legacy-composer-in-app-announcement';
import simpleLegacyComposerInAppBigAnnouncementPreset from './simple-legacy-composer-in-app-big-announcement';
import simpleLegacyComposerInAppChatPreset from './simple-legacy-composer-in-app-chat';
import twitterDirectMessagePreset from './twitterDirectMessage';
import { and, or } from '@ember/object/computed';
import Em from 'ember';
const PRESETS = {
  default: defaultConfig,
  answer: answerPreset,
  article: articlePreset,
  botBuilder: botBuilderPreset,
  botBuilderWithAttributeInserter: botBuilderWithAttributeInserterPreset,
  changePage: changePagePreset,
  educateAutoMessage: educateAutoMessagePreset,
  simpleComposer: simpleComposerPreset,
  simpleComposerCanary: simpleComposerCanaryPreset,
  simpleLegacyComposerInAppAnnouncementPreset,
  simpleLegacyComposerInAppBigAnnouncementPreset,
  simpleLegacyComposerInAppChatPreset,
  simpleLegacyComposerEmailPreset,
  readOnly: readOnlyPreset,
  readOnlyChat: readOnlyChatPreset,
  readOnlyCanary: readOnlyCanaryPreset,
  readOnlyEmail: readOnlyEmailPreset,
  inAppAnnouncement: inAppAnnouncementPreset,
  inAppAnnouncementMobile: inAppAnnouncementMobilePreset,
  inAppAnnouncementVideo: inAppAnnouncementVideoPreset,
  inAppBigAnnouncement: inAppBigAnnouncementPreset,
  inAppBigAnnouncementMobile: inAppBigAnnouncementMobilePreset,
  inAppBigAnnouncementVideo: inAppBigAnnouncementVideoPreset,
  inAppMv2Chat: inAppMv2ChatPreset,
  inAppMv2ChatMobile: inAppMv2ChatMobilePreset,
  inAppChat: inAppChatPreset,
  inAppChatMobile: inAppChatMobilePreset,
  inAppPointer: inAppPointerPreset,
  inAppChatVideo: inAppChatVideoPreset,
  email: emailPreset,
  emailPlain: emailPlainPreset,
  facebookMessage: facebookMessagePreset,
  twitterDirectMessage: twitterDirectMessagePreset,
  debug: debugPreset,
  inboxReply,
  inboxReplyDisableUploads,
  inboxNote,
  inboxNoteDisableUploads,
  conversationCardReply,
  conversationCardReplyDisableUploads,
  conversationCardNote,
  conversationCardNoteDisableUploads,
  pushOnly: pushOnlyPreset,
  banner: bannerPreset,
  bannerReadOnly: bannerReadOnlyPreset,
  pushOnlyReadOnly: pushOnlyReadOnlyPreset,
  imageTextInput: imageTextInputPreset,
  pushOnlyDisallowAttribute,
  savedContent,
  savedReply: savedReplyPreset,
  appStore,
  developerHub,
  productTourStep,
  productTourStepVideo,
  carouselScreenContentBlock
};
const Config = Em.Object.extend({
  attributes: [],
  previewContext: null,
  autoFocus: or('autoFocusTopLeft', 'autoFocusBottomRight'),
  needsMediaInserter: or('allowImage', 'allowButton', 'allowSocial', 'allowVideo'),
  showMediaInserter: and('allowMediaInserter', 'needsMediaInserter'),
  needsTextFormatter: or('allowBold', 'allowItalic', 'allowHeading', 'allowSubheading', 'allowAnchor', 'allowAlignment')
}).reopenClass({
  createFromPreset(name) {
    let config = Config.create();
    let preset = this._getPreset(name);
    if (preset) {
      config.setProperties(PRESETS['default']);
      config.setProperties(preset);
      config.set('name', name);
      return config;
    } else {
      throw new Error(`Invalid preset specified: ${name}`);
    }
  },
  convertToPreset(config, name) {
    let preset = this._getPreset(name);
    if (preset) {
      config.setProperties(PRESETS['default']);
      config.setProperties(preset);
      config.set('name', name);
    } else {
      throw new Error(`Invalid preset specified: ${name}`);
    }
  },
  _getPreset(name) {
    let preset = PRESETS[name];
    if (!preset && name.indexOf('Canary') > -1 && PRESETS[this._nameMinusCanaryWord(name)]) {
      preset = PRESETS[this._nameMinusCanaryWord(name)];
    }
    return preset;
  },
  _nameMinusCanaryWord(name) {
    return name.substring(0, name.indexOf('Canary'));
  }
});
export default Config;